import { useEffect } from "react";

const Seo = ({ title, description }) => {
  useEffect(() => {
    document.title = title;
    const set = (selector, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const attr = selector.match(/\[(name|property)=/)[1];
        el.setAttribute(attr, selector.match(/="([^"]+)"/)[1]);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    const image = `${window.location.origin}/og-image.png`;
    set('meta[name="description"]', description);
    set('meta[property="og:title"]', title);
    set('meta[property="og:description"]', description);
    set('meta[property="og:image"]', image);
    set('meta[property="og:image:width"]', "1200");
    set('meta[property="og:image:height"]', "630");
    set('meta[property="og:image:alt"]', "Good Work Web Co. — Good websites for people doing good work");
    set('meta[name="twitter:card"]', "summary_large_image");
    set('meta[name="twitter:title"]', title);
    set('meta[name="twitter:description"]', description);
    set('meta[name="twitter:image"]', image);
  }, [title, description]);
  return null;
};

export default Seo;
